/**
 * @file High level controller for the response file generating contents.
 * This component generates the steps to show based on the products selection from the customer.
 * @author Haonan Yu(haoyu@microStrategy.com)
 */

import React from 'react';
import 'antd/dist/antd.css';
import { pageObjects as winPageObjects } from '../../Utils/WindowsDataLoader';
import { pageObjects as linPageObjects } from '../../Utils/LinuxDataLoader';

import WinCustomerInfoAndInstallationDirect from '../ContentPages/WindowsCustom/CustomerInfoAndInstallationDirect/WinCustomerInfoAndInstallationDirect';
import WinFeatureSelection from '../ContentPages/WindowsCustom/FeatureSelection/WinFeatureSelection';
import WinTopologyConfiguration from '../ContentPages/WindowsCustom/TopologyConfiguration/WinTopologyConfiguration';
import WinTelemetryConfiguration from '../ContentPages/WindowsCustom/TelemetryConfiguration/WinTelemetryConfiguration';
import WinWebMobileVDS from '../ContentPages/WindowsCustom/WebMobileVDS/WinWebMobileVDS';
import WinPortalMDXVDS from '../ContentPages/WindowsCustom/PortalMDXVDS/WinPortalMDXVDS';
import WinMDXVDS from '../ContentPages/WindowsCustom/MDXVDS/WinMDXVDS';
import WinOfficeConfiguration from '../ContentPages/WindowsCustom/OfficeConfiguration/WinOfficeConfiguration';
import WinIntelligenceServerConfiguration from '../ContentPages/WindowsCustom/IntelligenceServerConfiguration/WinIntelligenceServerConfiguration';
import WinNarrowcastServerConfiguration from '../ContentPages/WindowsCustom/NarrowcastServerConfiguration/WinNarrowcastServerConfiguration';
import WinSummary from '../ContentPages/WindowsCustom/Summary/WinSummary';
import WinFinalPage from '../ContentPages/WindowsUpdate/FinalPage/WinFinalPage';
import WinRemoteRepository from '../ContentPages/WindowsCustom/RemoteRepository/WinRemoteRepository';

import LinCustomerInfoAndInstallationDirect from '../ContentPages/Linux/CustomerInfoAndInstallationDirect/LinCustomerInfoAndInstallationDirect';
import LinFeatureSelection from '../ContentPages/Linux/FeatureSelection/LinFeatureSelection';
import LinRemoteRepository from '../ContentPages/Linux/RemoteRepository/LinRemoteRepository';
import LinTelemetryConfiguration from '../ContentPages/Linux/TelemetryConfiguration/LinTelemetryConfiguration';
import LinTopologyConfiguration from '../ContentPages/Linux/TopologyConfiguration/LinTopologyConfiguration';
import LinRegisteringAsService from '../ContentPages/Linux/RegisteringAsService/LinRegisteringAsService';
import LinSummary from '../ContentPages/Linux/Summary/LinSummary';
import LinFinalPage from '../ContentPages/LinuxUpdate/FinalPage/LinFinalPage';

//functions
import { generateSteps } from '../../Utils/utils';
import { initializePageObjectsMap } from '../../Utils/PageObjectsMapUtil';
import * as DEFINITIONS from '../../Utils/Constants';

const configurationContent = (props) => {
    const win20ExpressWholeSteps = [
        <WinCustomerInfoAndInstallationDirect
            nextStep={props.nextStep}
            steps={props.steps}
            getOriginState={props.getOriginState}
            setOriginState={props.setOriginState}
            setBasicState={props.setBasicState}
            deepestStep={props.deepestStep}
            useOs={props.useOs}
            useMode={props.useMode}
        />,
        <WinSummary
            nextStep={props.nextStep}
            backStep={props.backStep}
            steps={props.steps}
            getOriginState={props.getOriginState}
            setOriginState={props.setOriginState}
            deepestStep={props.deepestStep}
            useOs={props.useOs}
            useMode={props.useMode}
            useVersion={props.useVersion}
        />,
    ];

    const win21ExpressWholeSteps = win20ExpressWholeSteps;
    const win11_4_12_ExpressWholeSteps = win21ExpressWholeSteps;
    const win11_5_03_ExpressWholeSteps = win21ExpressWholeSteps;
    const win11_5_06_ExpressWholeSteps = win21ExpressWholeSteps;
    const win11_5_09_ExpressWholeSteps = win21ExpressWholeSteps;
    const win11_5_12_ExpressWholeSteps = win21ExpressWholeSteps;
    const win11_6_03_ExpressWholeSteps = win21ExpressWholeSteps;
    const win11_6_06_ExpressWholeSteps = win21ExpressWholeSteps;
    const win11_6_09_ExpressWholeSteps = win21ExpressWholeSteps;

    const win21CustomWholeSteps = [
        <WinCustomerInfoAndInstallationDirect
            nextStep={props.nextStep}
            steps={props.steps}
            getOriginState={props.getOriginState}
            setOriginState={props.setOriginState}
            setBasicState={props.setBasicState}
            deepestStep={props.deepestStep}
            useOs={props.useOs}
        />,
        <WinFeatureSelection
            nextStep={props.nextStep}
            backStep={props.backStep}
            steps={props.steps}
            getOriginState={props.getOriginState}
            setOriginState={props.setOriginState}
            deepestStep={props.deepestStep}
            useOs={props.useOs}
            useVersion={props.useVersion}
        />,
        <WinRemoteRepository
            nextStep={props.nextStep}
            backStep={props.backStep}
            steps={props.steps}
            getOriginState={props.getOriginState}
            setOriginState={props.setOriginState}
            deepestStep={props.deepestStep}
            useOs={props.useOs}
            useVersion={props.useVersion}
        />,
        <WinTopologyConfiguration
            nextStep={props.nextStep}
            backStep={props.backStep}
            steps={props.steps}
            getOriginState={props.getOriginState}
            setOriginState={props.setOriginState}
            deepestStep={props.deepestStep}
            useOs={props.useOs}
        />,
        <WinTelemetryConfiguration
            nextStep={props.nextStep}
            backStep={props.backStep}
            steps={props.steps}
            getOriginState={props.getOriginState}
            setOriginState={props.setOriginState}
            deepestStep={props.deepestStep}
            useOs={props.useOs}
        />,
        <WinWebMobileVDS
            nextStep={props.nextStep}
            backStep={props.backStep}
            steps={props.steps}
            getOriginState={props.getOriginState}
            setOriginState={props.setOriginState}
            deepestStep={props.deepestStep}
            useOs={props.useOs}
        />,
        <WinPortalMDXVDS
            nextStep={props.nextStep}
            backStep={props.backStep}
            steps={props.steps}
            getOriginState={props.getOriginState}
            setOriginState={props.setOriginState}
            deepestStep={props.deepestStep}
            useOs={props.useOs}
        />,
        <WinOfficeConfiguration
            nextStep={props.nextStep}
            backStep={props.backStep}
            steps={props.steps}
            getOriginState={props.getOriginState}
            setOriginState={props.setOriginState}
            deepestStep={props.deepestStep}
            useOs={props.useOs}
        />,
        <WinIntelligenceServerConfiguration
            nextStep={props.nextStep}
            backStep={props.backStep}
            steps={props.steps}
            getOriginState={props.getOriginState}
            setOriginState={props.setOriginState}
            deepestStep={props.deepestStep}
            useOs={props.useOs}
        />,
        <WinNarrowcastServerConfiguration
            nextStep={props.nextStep}
            backStep={props.backStep}
            steps={props.steps}
            getOriginState={props.getOriginState}
            setOriginState={props.setOriginState}
            deepestStep={props.deepestStep}
            useOs={props.useOs}
        />,
        <WinSummary
            nextStep={props.nextStep}
            backStep={props.backStep}
            steps={props.steps}
            getOriginState={props.getOriginState}
            setOriginState={props.setOriginState}
            deepestStep={props.deepestStep}
            useOs={props.useOs}
            useMode={props.useMode}
            useVersion={props.useVersion}
        />,
    ];

    const win21CustomNewSteps = [
        <WinCustomerInfoAndInstallationDirect
            nextStep={props.nextStep}
            steps={props.steps}
            getOriginState={props.getOriginState}
            setOriginState={props.setOriginState}
            setBasicState={props.setBasicState}
            deepestStep={props.deepestStep}
            useOs={props.useOs}
        />,
        <WinFeatureSelection
            nextStep={props.nextStep}
            backStep={props.backStep}
            steps={props.steps}
            getOriginState={props.getOriginState}
            setOriginState={props.setOriginState}
            deepestStep={props.deepestStep}
            useOs={props.useOs}
            useVersion={props.useVersion}
        />,
        <WinRemoteRepository
            nextStep={props.nextStep}
            backStep={props.backStep}
            steps={props.steps}
            getOriginState={props.getOriginState}
            setOriginState={props.setOriginState}
            deepestStep={props.deepestStep}
            useOs={props.useOs}
            useVersion={props.useVersion}
        />,
        <WinTopologyConfiguration
            nextStep={props.nextStep}
            backStep={props.backStep}
            steps={props.steps}
            getOriginState={props.getOriginState}
            setOriginState={props.setOriginState}
            deepestStep={props.deepestStep}
            useOs={props.useOs}
        />,
        <WinTelemetryConfiguration
            nextStep={props.nextStep}
            backStep={props.backStep}
            steps={props.steps}
            getOriginState={props.getOriginState}
            setOriginState={props.setOriginState}
            deepestStep={props.deepestStep}
            useOs={props.useOs}
        />,
        <WinWebMobileVDS
            nextStep={props.nextStep}
            backStep={props.backStep}
            steps={props.steps}
            getOriginState={props.getOriginState}
            setOriginState={props.setOriginState}
            deepestStep={props.deepestStep}
            useOs={props.useOs}
        />,
        <WinMDXVDS
            nextStep={props.nextStep}
            backStep={props.backStep}
            steps={props.steps}
            getOriginState={props.getOriginState}
            setOriginState={props.setOriginState}
            deepestStep={props.deepestStep}
            useOs={props.useOs}
        />,
        <WinPortalMDXVDS
            nextStep={props.nextStep}
            backStep={props.backStep}
            steps={props.steps}
            getOriginState={props.getOriginState}
            setOriginState={props.setOriginState}
            deepestStep={props.deepestStep}
            useOs={props.useOs}
        />,
        <WinIntelligenceServerConfiguration
            nextStep={props.nextStep}
            backStep={props.backStep}
            steps={props.steps}
            getOriginState={props.getOriginState}
            setOriginState={props.setOriginState}
            deepestStep={props.deepestStep}
            useOs={props.useOs}
        />,
        <WinNarrowcastServerConfiguration
            nextStep={props.nextStep}
            backStep={props.backStep}
            steps={props.steps}
            getOriginState={props.getOriginState}
            setOriginState={props.setOriginState}
            deepestStep={props.deepestStep}
            useOs={props.useOs}
        />,
        <WinSummary
            nextStep={props.nextStep}
            backStep={props.backStep}
            steps={props.steps}
            getOriginState={props.getOriginState}
            setOriginState={props.setOriginState}
            deepestStep={props.deepestStep}
            useOs={props.useOs}
            useMode={props.useMode}
            useVersion={props.useVersion}
        />,
    ];

    const win11_4_12_CustomWholeSteps = win21CustomWholeSteps;
    const win11_5_03_CustomWholeSteps = win21CustomWholeSteps;
    const win11_5_06_CustomWholeSteps = win21CustomWholeSteps;
    const win11_5_09_CustomWholeSteps = win21CustomWholeSteps;
    const win11_5_12_CustomWholeSteps = win21CustomWholeSteps;
    const win11_6_03_CustomWholeSteps = win21CustomNewSteps;
    const win11_6_06_CustomWholeSteps = win21CustomNewSteps;
    const win11_6_09_CustomWholeSteps = win21CustomNewSteps;

    const win21Update1Steps = [
        <WinFinalPage
            steps={props.steps}
            useOs={props.useOs}
            useMode={props.useMode}
            useVersion={props.useVersion}
            getOriginState={props.getOriginState}
            setOriginState={props.setOriginState}
            setBasicState={props.setBasicState}
        />,
    ];

    const lin21WholeSteps = [
        <LinCustomerInfoAndInstallationDirect
            nextStep={props.nextStep}
            steps={props.steps}
            getOriginState={props.getOriginState}
            setOriginState={props.setOriginState}
            setBasicState={props.setBasicState}
            deepestStep={props.deepestStep}
            useOs={props.useOs}
        />,
        <LinFeatureSelection
            nextStep={props.nextStep}
            backStep={props.backStep}
            steps={props.steps}
            getOriginState={props.getOriginState}
            setOriginState={props.setOriginState}
            deepestStep={props.deepestStep}
            useOs={props.useOs}
            useVersion={props.useVersion}
        />,
        <LinRemoteRepository
            nextStep={props.nextStep}
            backStep={props.backStep}
            steps={props.steps}
            getOriginState={props.getOriginState}
            setOriginState={props.setOriginState}
            deepestStep={props.deepestStep}
            useOs={props.useOs}
            useVersion={props.useVersion}
        />,
        <LinTelemetryConfiguration
            nextStep={props.nextStep}
            backStep={props.backStep}
            steps={props.steps}
            getOriginState={props.getOriginState}
            setOriginState={props.setOriginState}
            deepestStep={props.deepestStep}
            useOs={props.useOs}
        />,
        <LinTopologyConfiguration
            nextStep={props.nextStep}
            backStep={props.backStep}
            steps={props.steps}
            getOriginState={props.getOriginState}
            setOriginState={props.setOriginState}
            deepestStep={props.deepestStep}
            useOs={props.useOs}
        />,
        <LinRegisteringAsService
            nextStep={props.nextStep}
            backStep={props.backStep}
            steps={props.steps}
            getOriginState={props.getOriginState}
            setOriginState={props.setOriginState}
            deepestStep={props.deepestStep}
            useOs={props.useOs}
        />,
        <LinSummary
            nextStep={props.nextStep}
            backStep={props.backStep}
            steps={props.steps}
            getOriginState={props.getOriginState}
            setOriginState={props.setOriginState}
            deepestStep={props.deepestStep}
            useOs={props.useOs}
            useMode={props.useMode}
            useVersion={props.useVersion}
        />,
    ];

    const lin11_4_12_wholeSteps = lin21WholeSteps;
    const lin11_5_03_wholeSteps = lin21WholeSteps;
    const lin11_5_06_wholeSteps = lin21WholeSteps;
    const lin11_5_09_wholeSteps = lin21WholeSteps;
    const lin11_5_12_wholeSteps = lin21WholeSteps;
    const lin11_6_03_wholeSteps = lin21WholeSteps;
    const lin11_6_06_wholeSteps = lin21WholeSteps;
    const lin11_6_09_wholeSteps = lin21WholeSteps;

    const lin21Update1Steps = [
        <LinFinalPage
            steps={props.steps}
            useOs={props.useOs}
            useMode={props.useMode}
            useVersion={props.useVersion}
            getOriginState={props.getOriginState}
            setOriginState={props.setOriginState}
            setBasicState={props.setBasicState}
        />,
    ];

    let workFlow = null;
    let pageObjects;
    let workSteps;
    switch (props.useOs) {
        case DEFINITIONS.LINUX:
            pageObjects = linPageObjects;
            switch (props.useVersion) {
                case DEFINITIONS.M11_6_09:
                    workSteps = lin11_6_09_wholeSteps;
                    break;
                case DEFINITIONS.M11_6_06:
                    workSteps = lin11_6_06_wholeSteps;
                    break;
                case DEFINITIONS.M11_6_03:
                    workSteps = lin11_6_03_wholeSteps;
                    break;
                case DEFINITIONS.M11_5_12:
                    workSteps = lin11_5_12_wholeSteps;
                    break;
                case DEFINITIONS.M11_5_09:
                    workSteps = lin11_5_09_wholeSteps;
                    break;
                case DEFINITIONS.M11_5_06:
                    workSteps = lin11_5_06_wholeSteps;
                    break;
                case DEFINITIONS.M11_5_03:
                    workSteps = lin11_5_03_wholeSteps;
                    break;
                case DEFINITIONS.M11_4_12:
                    workSteps = lin11_4_12_wholeSteps;
                    break;
                default:
            }
            break;
        case DEFINITIONS.WINDOWS:
            pageObjects = winPageObjects;
            switch (props.useVersion) {
                case DEFINITIONS.M11_6_09:
                    switch (props.useMode) {
                        case DEFINITIONS.CUSTOM_INSTALL:
                            workSteps = win11_6_09_CustomWholeSteps;
                            break;
                        case DEFINITIONS.EXPRESS_INSTALL:
                            workSteps = win11_6_09_ExpressWholeSteps;
                            break;
                        default:
                    }
                    break;
                case DEFINITIONS.M11_6_06:
                    switch (props.useMode) {
                        case DEFINITIONS.CUSTOM_INSTALL:
                            workSteps = win11_6_06_CustomWholeSteps;
                            break;
                        case DEFINITIONS.EXPRESS_INSTALL:
                            workSteps = win11_6_06_ExpressWholeSteps;
                            break;
                        default:
                    }
                    break;
                case DEFINITIONS.M11_6_03:
                    switch (props.useMode) {
                        case DEFINITIONS.CUSTOM_INSTALL:
                            workSteps = win11_6_03_CustomWholeSteps;
                            break;
                        case DEFINITIONS.EXPRESS_INSTALL:
                            workSteps = win11_6_03_ExpressWholeSteps;
                            break;
                        default:
                    }
                    break;
                case DEFINITIONS.M11_5_12:
                    switch (props.useMode) {
                        case DEFINITIONS.CUSTOM_INSTALL:
                            workSteps = win11_5_12_CustomWholeSteps;
                            break;
                        case DEFINITIONS.EXPRESS_INSTALL:
                            workSteps = win11_5_12_ExpressWholeSteps;
                            break;
                        default:
                    }
                    break;
                case DEFINITIONS.M11_5_09:
                    switch (props.useMode) {
                        case DEFINITIONS.CUSTOM_INSTALL:
                            workSteps = win11_5_09_CustomWholeSteps;
                            break;
                        case DEFINITIONS.EXPRESS_INSTALL:
                            workSteps = win11_5_09_ExpressWholeSteps;
                            break;
                        default:
                    }
                    break;
                case DEFINITIONS.M11_5_06:
                    switch (props.useMode) {
                        case DEFINITIONS.CUSTOM_INSTALL:
                            workSteps = win11_5_06_CustomWholeSteps;
                            break;
                        case DEFINITIONS.EXPRESS_INSTALL:
                            workSteps = win11_5_06_ExpressWholeSteps;
                            break;
                        default:
                    }
                    break;
                case DEFINITIONS.M11_5_03:
                    switch (props.useMode) {
                        case DEFINITIONS.CUSTOM_INSTALL:
                            workSteps = win11_5_03_CustomWholeSteps;
                            break;
                        case DEFINITIONS.EXPRESS_INSTALL:
                            workSteps = win11_5_03_ExpressWholeSteps;
                            break;
                        default:
                    }
                    break;
                case DEFINITIONS.M11_4_12:
                    switch (props.useMode) {
                        case DEFINITIONS.CUSTOM_INSTALL:
                            workSteps = win11_4_12_CustomWholeSteps;
                            break;
                        case DEFINITIONS.EXPRESS_INSTALL:
                            workSteps = win11_4_12_ExpressWholeSteps;
                            break;
                        default:
                    }
                    break;
                default:
            }
            break;
        default:
    }
    workFlow = generateSteps(pageObjects, workSteps, props);
    initializePageObjectsMap(pageObjects);

    return workFlow[props.steps];
};

export default configurationContent;
